import axios from 'axios'
import * as types from '../mutation-types'
import { getPromotions } from '@/api/url'
import { getInfo } from '@/assets/func'

const state = {
  promoList: [],
  promoCnt: 0
}

const actions = {
  // get notice list
  getNoticeRequest: ({ commit }) => {
    // params -> &uid=[사용자ID]
    let uid = getInfo().uid
    let url = getPromotions + uid
    axios.get(url).then((res) => {
      commit(types.SET_PROMO_LIST, {promo: res.data})
    }, (err) => {
      console.error(err)
    })
  }
}

const mutations = {
  [types.SET_PROMO_LIST]: (state, {promo}) => {
    state.promoList = promo
    state.promoCnt = promo.length
  }
}

export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/promotion.js